// 🔧 volunteer_repository.js
// ✅ Purpose: Firestore repository for Volunteer Engine demo data
// ✅ Features:
// - Writes volunteer activities
// - Writes volunteer time slots
// - Uses the production Firestore structure
// - Uses Firestore-generated document IDs
// - No crypto.randomUUID()
// - No business logic
// - No data generation
// - Repository pattern only
// - Fully block-commented for clarity and future devs

import {
  collection,
  doc,
  writeBatch,
  serverTimestamp,
} from "firebase/firestore";

import { db } from "../../../firebase";

export const saveVolunteerData = async ({
  eventId,
  volunteerPlan,
} = {}) => {
  console.log("💾 Saving Volunteer Engine demo data.");

  if (!eventId) {
    throw new Error("Volunteer Repository requires an eventId.");
  }

  if (!volunteerPlan) {
    throw new Error("Volunteer Repository requires volunteerPlan.");
  }

  const batch = writeBatch(db);

  const volunteerCollection = collection(
    db,
    "events",
    eventId,
    "volunteers"
  );

  volunteerPlan.activities.forEach((activity) => {
    const activityRef = doc(
      volunteerCollection,
      activity.id
    );

    batch.set(activityRef, {
      activityId: activity.id,
      title: activity.title,
      description: activity.description,
      displayOrder: activity.displayOrder,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
      demoSeed: true,
    });
  });

  volunteerPlan.timeSlots.forEach((slot) => {
    const slotRef = doc(
      collection(
        db,
        "events",
        eventId,
        "volunteers",
        slot.activityId,
        "timeSlots"
      )
    );

    batch.set(slotRef, {
      title: slot.title,
      description: slot.description,
      displayOrder: slot.displayOrder,
      requiredVolunteers: slot.requiredVolunteers,
      volunteersNeeded: slot.requiredVolunteers,
      assignedUsers: slot.assignedUsers || [],
      assignedUserIds: slot.assignedUserIds || [],
      startDateTime: slot.startDateTime,
      endDateTime: slot.endDateTime,
      startTime: slot.startDateTime,
      endTime: slot.endDateTime,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
      demoSeed: true,
    });
  });

  await batch.commit();

  console.log("✅ Volunteer Engine repository completed.", {
    activities: volunteerPlan.activities.length,
    timeSlots: volunteerPlan.timeSlots.length,
  });

  return {
    activities: volunteerPlan.activities,
    timeSlots: volunteerPlan.timeSlots,
  };
};
